/**
 * Colored terminal output from diff summary markdown
 */

/**
 * Print a diff summary to the terminal with ANSI colors.
 * Parses the markdown summary from the backend diff endpoint.
 */
export function printDiff(summary: string): void {
  const lines = summary.split('\n');

  for (const line of lines) {
    if (line.startsWith('**') && line.endsWith('**')) {
      // Section header
      console.log(`\n\x1b[1m${line.replace(/\*\*/g, '')}\x1b[0m`);
    } else if (line.trimStart().startsWith('+ ')) {
      // Addition — green
      console.log(`\x1b[32m${line}\x1b[0m`);
    } else if (line.trimStart().startsWith('- ')) {
      // Deletion — red
      console.log(`\x1b[31m${line}\x1b[0m`);
    } else if (line.trimStart().startsWith('~ ')) {
      // Modification — yellow
      console.log(`\x1b[33m${line}\x1b[0m`);
    } else if (line.includes('(no changes)')) {
      // No changes — dim
      console.log(`\x1b[2m${line}\x1b[0m`);
    } else {
      console.log(line);
    }
  }
  console.log(); // trailing newline
}
